import { Mail, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { CONTACT_EMAIL } from "../config";

export default function ContactSection() {
    return (
        <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5 overflow-hidden">
            <div className="absolute top-0 left-1/4 w-[30rem] h-[20rem] gold-glow pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
                <Reveal>
                    <Overline>Contact</Overline>
                    <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                        Let&rsquo;s <span className="italic text-amber-500">talk</span>
                    </h2>
                    <p className="mt-8 text-base sm:text-lg leading-relaxed text-zinc-400 max-w-2xl">
                        Questions about LookAura, press enquiries, or partnership conversations — we&rsquo;d love to hear from you.
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="contact-email-link"
                        className="group mt-10 inline-flex items-center gap-4 border border-white/10 hover:border-amber-600/50 bg-[#050505] px-8 py-6 transition-colors duration-300"
                    >
                        <Mail className="w-6 h-6 text-amber-500" strokeWidth={1.5} />
                        <span className="font-serif-display text-xl sm:text-2xl text-[#FAFAFA]">{CONTACT_EMAIL}</span>
                        <ArrowRight className="w-5 h-5 text-zinc-500 transition-transform duration-300 group-hover:translate-x-1" />
                    </a>
                    <p className="mt-5 text-xs font-mono-accent text-zinc-500" data-testid="contact-placeholder-note">
                        Placeholder contact address — replace with the official LookAura email.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
